import RestClient from "@/api/utils/baseRestClient";
import atmoClient from "@/setup/clients/atmoClient";

export const SumClient = new RestClient(atmoClient, "sums");
